export const SETTING_TO_GROUP_TYPE = 'SETTING_TO_GROUP_TYPE';
export const GROUP_TYPE_SET_SUCCESS = 'GROUP_TYPE_SET_SUCCESS';
export const GROUP_TYPE_SET_FAILED = 'GROUP_TYPE_SET_FAILED';